import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Navbar } from '../navbar/navbar';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.html',
  styleUrls: ['./base-layout.scss'],
  standalone: true,
  imports: [RouterOutlet, Navbar]
})
export class BaseLayout {}
